import React from 'react';
import { ShieldCheck, Download, Zap, CheckCircle2, Lock } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function OfferSection() {
  return <section className="bg-darker py-20 md:py-32 relative overflow-hidden" id="offer" data-id="element-108">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full max-h-[600px] bg-primary/20 rounded-full blur-[120px] pointer-events-none" data-id="element-109"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-110">
        <FadeIn data-id="element-111">
          <div className="bg-white rounded-3xl overflow-hidden shadow-2xl border-4 border-primary/20" data-id="element-112">
            {/* Top Banner */}
            <div className="bg-primary text-white text-center py-3 px-4 font-bold tracking-wide uppercase text-sm md:text-base" data-id="element-113">
              Oferta válida solo por hoy
            </div>

            <div className="p-8 md:p-12 lg:p-16 flex flex-col lg:flex-row gap-12 items-center" data-id="element-114">
              {/* Left: Product Image */}
              <div className="w-full lg:w-5/12 relative" data-id="element-115">
                <div className="absolute -top-4 -right-4 bg-red-500 text-white font-black text-xl md:text-2xl py-4 px-6 rounded-full shadow-xl transform rotate-12 z-20 border-4 border-white" data-id="element-116">
                  50% OFF
                </div>
                <img src="https://images.unsplash.com/photo-1526506114861-13419b928f2a?auto=format&fit=crop&w=600&q=80" alt="5K Sin Rendirse Programa Completo" className="w-full rounded-2xl shadow-lg relative z-10" data-id="element-117" />
              </div>

              {/* Right: Offer Details */}
              <div className="w-full lg:w-7/12 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-118">
                <h2 className="text-3xl md:text-4xl font-black text-dark mb-2" data-id="element-119">
                  5K SIN RENDIRSE
                </h2>
                <p className="text-xl text-gray-600 mb-8 font-medium" data-id="element-120">
                  El sistema completo + Todos los bonos
                </p>

                <div className="flex items-end gap-4 mb-8" data-id="element-121">
                  <p className="text-3xl text-gray-400 line-through decoration-red-500 decoration-4 font-bold mb-1" data-id="element-122">
                    $30.000
                  </p>
                  <p className="text-5xl md:text-6xl font-black text-dark" data-id="element-123">
                    $13.999{' '}
                    <span className="text-xl text-gray-500 font-medium" data-id="element-124">
                      ARS
                    </span>
                  </p>
                </div>

                <div className="space-y-3 mb-10 w-full" data-id="element-125">
                  <div className="flex items-center gap-3 bg-gray-50 p-3 rounded-lg" data-id="element-126">
                    <Zap className="w-5 h-5 text-primary flex-shrink-0" data-id="element-127" />
                    <p className="font-medium text-gray-800" data-id="element-128">
                      Acceso inmediato
                    </p>
                  </div>
                  <div className="flex items-center gap-3 bg-gray-50 p-3 rounded-lg" data-id="element-129">
                    <Download className="w-5 h-5 text-primary flex-shrink-0" data-id="element-130" />
                    <p className="font-medium text-gray-800" data-id="element-131">
                      Descarga digital
                    </p>
                  </div>
                  <div className="flex items-center gap-3 bg-gray-50 p-3 rounded-lg" data-id="element-132">
                    <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0" data-id="element-133" />
                    <p className="font-medium text-gray-800" data-id="element-134">
                      Todos los bonos incluidos
                    </p>
                  </div>
                </div>

                <CTAButton fullWidth className="py-5 text-xl mb-6 shadow-xl" data-id="element-135">
                  QUIERO MI ACCESO AHORA →
                </CTAButton>

                <div className="flex flex-col items-center gap-4 w-full" data-id="element-136">
                  <div className="flex items-center justify-center gap-2 text-sm text-gray-500 font-medium" data-id="element-137">
                    <Lock className="w-4 h-4" data-id="element-138" />
                    <span data-id="element-139">Pago 100% Seguro y Encriptado</span>
                  </div>
                  {/* Payment Icons Placeholder */}
                  <div className="flex gap-2 opacity-60" data-id="element-140">
                    <div className="w-10 h-6 bg-gray-200 rounded" data-id="element-141"></div>
                    <div className="w-10 h-6 bg-gray-200 rounded" data-id="element-142"></div>
                    <div className="w-10 h-6 bg-gray-200 rounded" data-id="element-143"></div>
                    <div className="w-10 h-6 bg-gray-200 rounded" data-id="element-144"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Guarantee Bar */}
            <div className="bg-gray-50 border-t border-gray-100 p-6 md:p-8" data-id="element-145">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-center sm:text-left" data-id="element-146">
                <ShieldCheck className="w-16 h-16 text-success flex-shrink-0" data-id="element-147" />
                <div data-id="element-148">
                  <h4 className="text-xl font-bold text-dark mb-1" data-id="element-149">
                    Garantía de 7 Días
                  </h4>
                  <p className="text-gray-600" data-id="element-150">
                    Probalo durante 7 días. Si no es para vos, te devolvemos el
                    dinero. Sin preguntas.{' '}
                    <span className="font-bold text-dark" data-id="element-151">
                      El riesgo es nuestro.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}